import { withNavBar } from '../../shared/NavBar/NavBar';
import AccountForm from '../../shared/AccountForm/AccountForm';
import { ReduxStore } from '../../../store/reducers';
import { connect } from 'react-redux';

const Profile = ({userObject}: IProfileProps) => {

  return (
    <div className="profile" data-testid="user-profile">
      <div className="row">
        <h4>My Profile</h4>
      </div>
      <AccountForm type="update" userObject={userObject} />
    </div>
  );
};

const stateToProps = (state: ReduxStore) => {
  return { userObject: state.User.UserObject }
}

export default withNavBar(connect(stateToProps)(Profile), true);
